import { NestedPublicVenueSerializer } from "@shared/modules/events/types/public";
import { PublicVenueSerializer } from "@app-contexts/dashboard/features/venues/data/types/venues";
import PublicBasedVenuesRepository from "@shared/modules/venue/repositories/PublicBasedVenuesRepository";
import { queryClient } from "../../api/utils/GlobalQueryClient";
import { QueryKeyManager } from "../../api/hooks/utils/queryKeyManager";
import { RQ_STALE_TIME_MS } from "../../api/types";

export * from "./getAdditionalParams";

// TODO: This really should be moved to the data layer and not a helper here. Should do that
// at some point. Marking as deprecated to discourage people from using it elsewhere.
// @deprecated
const publicBasedVenuesRepo = new PublicBasedVenuesRepository();
const keyManager = new QueryKeyManager(publicBasedVenuesRepo);

export const retrieveVenue = (venueId: number) => {
  const key = keyManager.generateKey(["retrieve", venueId]);

  return queryClient.fetchQuery<
    NestedPublicVenueSerializer | PublicVenueSerializer
  >({
    queryKey: key,
    queryFn: () => publicBasedVenuesRepo.retrieve(venueId),
    staleTime: RQ_STALE_TIME_MS,
  });
};
